import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './AdminToolCard.css';

export function AdminToolCard({ tool }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [isNavigating, setIsNavigating] = useState(false);

  const handleClick = async () => {
    if (tool?.path && !isNavigating) {
      // Don't navigate if we're already on the same path
      if (location.pathname === tool.path) {
        return;
      }

      setIsNavigating(true);
      try {
        await navigate(tool.path);
      } finally {
        // Reset after a short delay to allow for navigation
        setTimeout(() => setIsNavigating(false), 100);
      }
    }
  };

  return (
    <div
      className="admin-tool-card"
      onClick={handleClick}
    >
      <div className="admin-tool-icon">
        <i className={`fa-solid ${tool?.icon}`}></i>
      </div>
      <div className="admin-tool-content">
        <h3 className="admin-tool-title">{tool?.title}</h3>
        <p className="admin-tool-description">{tool?.description}</p>
      </div>
      <div className="admin-tool-arrow">
        <i className="fa-solid fa-chevron-right"></i>
      </div>
    </div>
  );
}